export default "__VITE_ASSET__BCdGRK$A__"